export default "__VITE_ASSET__QBlsN51x__"